export default __webpack_public_path__ + "static/media/Shine-min.a77598f1.webp";